import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import Cookies from "js-cookie";

import UserSidebar from "../components/user/UserSidebar";
import UserHeader from "../components/user/UserHeader";

import {
    userMe,
    getPremiumPapers
} from "../config/userApi";

import "./PremiumMCQ.css";


function PremiumPapers() {

    const navigate =
        useNavigate();


    const {
        subject
    } = useParams();


    /*
    |--------------------------------------------------------------------------
    | Decode Subject
    |--------------------------------------------------------------------------
    */

    const decodedSubject =
        decodeURIComponent(
            subject || ""
        );


    /*
    |--------------------------------------------------------------------------
    | State
    |--------------------------------------------------------------------------
    */

    const [
        sidebarOpen,
        setSidebarOpen
    ] = useState(false);


    const [
        name,
        setName
    ] = useState("Student");


    const [
        papers,
        setPapers
    ] = useState([]);


    const [
        loading,
        setLoading
    ] = useState(true);


    const [
        purchased,
        setPurchased
    ] = useState(false);


    const [
        error,
        setError
    ] = useState("");


    /*
    |--------------------------------------------------------------------------
    | Load Premium Papers
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        const loadPapers = async () => {

            try {

                setLoading(true);

                setError("");


                /*
                |--------------------------------------------------------------------------
                | Check Logged In User
                |--------------------------------------------------------------------------
                */

                const meResponse =
                    await userMe();


                console.log(
                    "USER ME STATUS:",
                    meResponse.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (
                    meResponse.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | User Response
                |--------------------------------------------------------------------------
                */

                const meResult =
                    await meResponse.json();


                console.log(
                    "USER ME RESPONSE:",
                    meResult
                );


                if (
                    !meResponse.ok
                ) {

                    throw new Error(
                        meResult.message ||
                        "Unable to verify user."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Set User Name
                |--------------------------------------------------------------------------
                */

                if (
                    meResult.user
                ) {

                    const username =
                        meResult.user.fullname ||
                        meResult.user.name ||
                        meResult.user.username ||
                        "Student";


                    setName(
                        username
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Get Premium Papers
                |--------------------------------------------------------------------------
                */

                const response =
                    await getPremiumPapers(
                        decodedSubject
                    );


                console.log(
                    "PREMIUM PAPERS STATUS:",
                    response.status
                );


                /*
                |--------------------------------------------------------------------------
                | Unauthorized
                |--------------------------------------------------------------------------
                */

                if (
                    response.status === 401
                ) {

                    Cookies.remove(
                        "username"
                    );


                    navigate(
                        "/login",
                        {
                            replace: true
                        }
                    );


                    return;

                }


                /*
                |--------------------------------------------------------------------------
                | API Response
                |--------------------------------------------------------------------------
                */

                const result =
                    await response.json();


                console.log(
                    "PREMIUM PAPERS RESPONSE:",
                    result
                );


                if (
                    !response.ok
                ) {

                    throw new Error(
                        result.message ||
                        "Unable to fetch premium papers."
                    );

                }


                /*
                |--------------------------------------------------------------------------
                | Purchase Status
                |--------------------------------------------------------------------------
                */

                setPurchased(
                    result.purchased === true
                );


                /*
                |--------------------------------------------------------------------------
                | Papers
                |--------------------------------------------------------------------------
                */

                setPapers(
                    Array.isArray(
                        result.data
                    )
                        ? result.data
                        : []
                );


            } catch (err) {

                console.error(
                    "PREMIUM PAPERS ERROR:",
                    err
                );


                setError(
                    err.message ||
                    "Unable to connect with server."
                );


            } finally {

                setLoading(false);

            }

        };


        loadPapers();

    }, [
        navigate,
        decodedSubject
    ]);


    /*
    |--------------------------------------------------------------------------
    | Go Back To Subjects
    |--------------------------------------------------------------------------
    */

    const goBack = () => {

        navigate(
            "/premium-mcq"
        );

    };


    /*
    |--------------------------------------------------------------------------
    | Start / Reattempt Practice
    |--------------------------------------------------------------------------
    */

    const startPractice = (
        paper
    ) => {

        console.log(
            "START PRACTICE PAPER:",
            paper
        );


        /*
        |--------------------------------------------------------------------------
        | Paper ID
        |--------------------------------------------------------------------------
        */

        const paperId =
            paper.paper_id;


        /*
        |--------------------------------------------------------------------------
        | Safety Check
        |--------------------------------------------------------------------------
        */

        if (!paperId) {

            console.error(
                "Paper ID is missing:",
                paper
            );


            setError(
                "Paper ID is missing. Unable to start practice."
            );


            return;

        }


        /*
        |--------------------------------------------------------------------------
        | Open Exam
        |--------------------------------------------------------------------------
        */

       navigate(
    `/premium-mcq/start/${encodeURIComponent(
        paperId
    )}`
);

    };


    /*
    |--------------------------------------------------------------------------
    | Get Attempt Count
    |--------------------------------------------------------------------------
    */

    const getAttemptCount = (
        paper
    ) => {

        const count =
            Number(
                paper.attempt_count ?? 0
            );


        if (
            Number.isNaN(count)
        ) {

            return 0;

        }


        return count;

    };


    /*
    |--------------------------------------------------------------------------
    | Get Button Text
    |--------------------------------------------------------------------------
    */

    const getActionText = (
        paper
    ) => {

        const attemptCount =
            getAttemptCount(
                paper
            );


        /*
        | 0 Attempts
        */

        if (
            attemptCount === 0
        ) {

            return "Start Practice";

        }


        /*
        | 1 Attempt
        */

        if (
            attemptCount === 1
        ) {

            return "Reattempt";

        }


        /*
        | 2+ Attempts
        */

        return "You Have Attempted";

    };


    /*
    |--------------------------------------------------------------------------
    | Get Status
    |--------------------------------------------------------------------------
    */

    const getAttemptStatus = (
        paper
    ) => {

        const attemptCount =
            getAttemptCount(
                paper
            );


        /*
        | 0 Attempts
        */

        if (
            attemptCount === 0
        ) {

            return {

                type:
                    "not-attempted",

                text:
                    "Not Attempted"

            };

        }


        /*
        | 1 Attempt
        */

        if (
            attemptCount === 1
        ) {

            return {

                type:
                    "attempted-once",

                text:
                    "Attempted Once"

            };

        }


        /*
        | 2+ Attempts
        */

        return {

            type:
                "attempted-complete",

            text:
                "You Have Attempted"

        };

    };


    /*
    |--------------------------------------------------------------------------
    | Loading
    |--------------------------------------------------------------------------
    */

    if (
        loading
    ) {

        return (

            <div className="user-dashboard">


                {/* =========================================================
                    SIDEBAR
                ========================================================= */}

                <UserSidebar

                    sidebarOpen={
                        sidebarOpen
                    }

                    setSidebarOpen={
                        setSidebarOpen
                    }

                />


                {/* =========================================================
                    MAIN
                ========================================================= */}

                <main className="dashboard-main">


                    {/* =====================================================
                        HEADER
                    ===================================================== */}

                    <UserHeader

                        name={
                            name
                        }

                        setSidebarOpen={
                            setSidebarOpen
                        }

                    />


                    {/* =====================================================
                        LOADING
                    ===================================================== */}

                    <div className="premium-mcq-loading">

                        <div
                            className="spinner-border text-primary"
                            role="status"
                        >

                            <span className="visually-hidden">

                                Loading...

                            </span>

                        </div>


                        <p className="mt-3">

                            Loading{" "}

                            {decodedSubject}

                            {" "}Papers...

                        </p>

                    </div>


                </main>

            </div>

        );

    }


    /*
    |--------------------------------------------------------------------------
    | Main UI
    |--------------------------------------------------------------------------
    */

    return (

        <div className="user-dashboard premium-mcq-page">


            {/* =========================================================
                SIDEBAR
            ========================================================= */}

            <UserSidebar

                sidebarOpen={
                    sidebarOpen
                }

                setSidebarOpen={
                    setSidebarOpen
                }

            />


            {/* =========================================================
                MAIN
            ========================================================= */}

            <main className="dashboard-main">


                {/* =====================================================
                    HEADER
                ===================================================== */}

                <UserHeader

                    name={
                        name
                    }

                    setSidebarOpen={
                        setSidebarOpen
                    }

                />


                {/* =====================================================
                    CONTENT
                ===================================================== */}

                <div className="dashboard-content">


                    {/* =====================================================
                        PAGE HEADER
                    ===================================================== */}

                    <section className="premium-mcq-header">


                        <div className="premium-header-content">


                            
                            {/* BADGE */}

                            <span className="premium-mcq-badge">

                                <i className="bi bi-gem"></i>

                                PREMIUM MCQs

                            </span>


                            {/* SUBJECT */}

                            <h1>

                                {decodedSubject}

                            </h1>


                            <p>

                                Select a paper to start your
                                premium MCQ practice.

                            </p>


                        </div>


                        <div className="premium-header-icon">

                            <i className="bi bi-journal-medical"></i>

                        </div>


                    </section>


                    {/* =====================================================
                        ERROR
                    ===================================================== */}

                    {error && (

                        <div className="alert alert-danger mt-4">

                            <i className="bi bi-exclamation-triangle-fill me-2"></i>

                            {error}

                        </div>

                    )}


                    {/* =====================================================
                        PREMIUM NOT PURCHASED
                    ===================================================== */}

                    {!error &&
                        !purchased && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-lock-fill"></i>

                                </div>


                                <span className="locked-label">

                                    PREMIUM ACCESS

                                </span>


                                <h2>

                                    Premium MCQs Locked

                                </h2>


                                <p>

                                    You have not purchased the
                                    Premium MCQ package yet.

                                </p>


                                <a

                                    href="https://imjo.in/58z6sD"

                                    target="_blank"

                                    rel="noreferrer"

                                    className="premium-purchase-btn"

                                >

                                    <i className="bi bi-gem"></i>

                                    Purchase MCQ Now

                                    <i className="bi bi-arrow-right"></i>

                                </a>


                            </div>

                        )
                    }


                    {/* =====================================================
                        NO PAPERS
                    ===================================================== */}

                    {!error &&
                        purchased &&
                        papers.length === 0 && (

                            <div className="premium-lock-card">


                                <div className="premium-lock-icon">

                                    <i className="bi bi-journal-x"></i>

                                </div>


                                <h3>

                                    No Papers Available

                                </h3>


                                <p>

                                    No premium papers are
                                    currently available for{" "}

                                    <strong>

                                        {decodedSubject}

                                    </strong>.

                                </p>


                                <button

                                    type="button"

                                    className="premium-purchase-btn"

                                    onClick={
                                        goBack
                                    }

                                >

                                    <i className="bi bi-arrow-left"></i>

                                    Back to Subjects

                                </button>


                            </div>

                        )
                    }


                    {/* =====================================================
                        PAPERS
                    ===================================================== */}

                    {!error &&
                        purchased &&
                        papers.length > 0 && (

                            <section className="premium-subjects-wrapper">


                                {/* =================================================
                                    SECTION HEADER
                                ================================================= */}

                                <div className="premium-section-header mb-4">


                                    <div className="subject-title-wrapper">


                                        <div className="subject-icon">

                                            <i className="bi bi-journal-medical"></i>

                                        </div>


                                        <div>

                                            <h2>

                                                {decodedSubject}
                                                {" "}
                                                Papers

                                            </h2>


                                            <p>

                                                {papers.length}

                                                {" "}

                                                {
                                                    papers.length === 1
                                                        ? "Paper"
                                                        : "Papers"
                                                }

                                                {" "}

                                                Available

                                            </p>

                                        </div>


                                    </div>


                                    <span className="premium-pro-badge">

                                        <i className="bi bi-gem"></i>

                                        PRO

                                    </span>


                                </div>


                                {/* =================================================
                                    PAPER CARDS
                                ================================================= */}

                                <div className="row g-4">


                                    {papers.map(
                                        (
                                            paper,
                                            index
                                        ) => {


                                            const attemptCount =
                                                getAttemptCount(
                                                    paper
                                                );


                                            const attemptStatus =
                                                getAttemptStatus(
                                                    paper
                                                );


                                            const isLocked =
                                                attemptCount >= 2;


                                            return (

                                                <div

                                                    className="col-xl-4 col-lg-6 col-md-6"

                                                    key={

                                                        paper.paper_id ||

                                                        paper.paper ||

                                                        index

                                                    }

                                                >


                                                    <div className="premium-paper-card">


                                                        {/* =================================================
                                                            CARD TOP
                                                        ================================================= */}

                                                        <div className="paper-card-top">


                                                            <div className="premium-paper-number">

                                                                {String(
                                                                    index + 1
                                                                ).padStart(
                                                                    2,
                                                                    "0"
                                                                )}

                                                            </div>


                                                            <span className="premium-card-badge">

                                                                <i className="bi bi-gem"></i>

                                                                PRO

                                                            </span>


                                                        </div>


                                                        {/* =================================================
                                                            PAPER ICON
                                                        ================================================= */}

                                                        <div className="premium-paper-icon">

                                                            <i className="bi bi-journal-medical"></i>

                                                        </div>


                                                        {/* =================================================
                                                            PAPER TITLE
                                                        ================================================= */}

                                                        <h3>

                                                            {paper.paper}

                                                        </h3>


                                                        {/* =================================================
                                                            QUESTION COUNT
                                                        ================================================= */}

                                                        <div className="premium-question-info">


                                                            <div className="question-icon">

                                                                <i className="bi bi-question-circle-fill"></i>

                                                            </div>


                                                            <div>

                                                                <strong>

                                                                    {
                                                                        paper.total_questions ||
                                                                        0
                                                                    }

                                                                </strong>


                                                                <span>

                                                                    Questions

                                                                </span>

                                                            </div>


                                                        </div>


                                                        {/* =================================================
                                                            ATTEMPT STATUS
                                                        ================================================= */}

                                                        {attemptCount === 0 && (

                                                            <div className="not-attempted-box">

                                                                <i className="bi bi-clock"></i>


                                                                <span>

                                                                    {attemptStatus.text}

                                                                </span>

                                                            </div>

                                                        )}


                                                        {attemptCount === 1 && (

                                                            <div className="attempted-box">

                                                                <div className="attempt-status">

                                                                    <i className="bi bi-check-circle-fill"></i>


                                                                    <span>

                                                                        {attemptStatus.text}

                                                                    </span>

                                                                </div>


                                                                <div className="score-wrapper">

                                                                    <small>

                                                                        Score

                                                                    </small>


                                                                    <strong>

                                                                        {
                                                                            paper.score ??
                                                                            0
                                                                        }

                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        )}


                                                        {attemptCount >= 2 && (

                                                            <div className="attempted-box">

                                                                <div className="attempt-status">

                                                                    <i className="bi bi-check-circle-fill"></i>


                                                                    <span>

                                                                        {attemptStatus.text}

                                                                    </span>

                                                                </div>


                                                                <div className="score-wrapper">

                                                                    <small>

                                                                        Score

                                                                    </small>


                                                                    <strong>

                                                                        {
                                                                            paper.score ??
                                                                            0
                                                                        }

                                                                    </strong>

                                                                </div>

                                                            </div>

                                                        )}


                                                        {/* =================================================
                                                            ACTION BUTTON
                                                        ================================================= */}

                                                        <button

                                                            type="button"

                                                            className={

                                                                `premium-action-btn ${
                                                                    isLocked
                                                                        ? "attempted-disabled-btn"
                                                                        : ""
                                                                }`

                                                            }

                                                            disabled={
                                                                isLocked
                                                            }

                                                            onClick={() => {

                                                                if (
                                                                    !isLocked
                                                                ) {

                                                                    startPractice(
                                                                        paper
                                                                    );

                                                                }

                                                            }}

                                                        >

                                                            <span>

                                                                {
                                                                    getActionText(
                                                                        paper
                                                                    )
                                                                }

                                                            </span>


                                                            <i

                                                                className={

                                                                    isLocked

                                                                        ? "bi bi-check-circle"

                                                                        : "bi bi-arrow-right"

                                                                }

                                                            ></i>

                                                        </button>


                                                    </div>

                                                </div>

                                            );

                                        }
                                    )}

                                </div>


                            </section>

                        )
                    }


                </div>


            </main>


        </div>

    );

}


export default PremiumPapers;